import { createContext } from 'react'

import { mapTransactionsData } from './mapTransactionsData'

export const PromptTransactionsContext = createContext<
  ReturnType<typeof mapTransactionsData> | undefined
>(undefined)
